import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import _ from 'lodash';

import OrderDeviceCollectionView from '../OrderDeviceCollectionView';
import OrderDeviceAdminCollectionView from '../OrderDeviceAdminCollectionView';

import tmplOrderDeviceSectionView from './OrderDeviceSectionView.hbs';

const OrderDeviceSectionView = View.extend({
  template: tmplOrderDeviceSectionView,

  className: 'order-device-section-view',

  ui: {
    orderDeviceCollection: '.order-device-collection',
    toggle: '.toggle'
  },

  events: {
    'click @ui.toggle': 'onClickToggle'
  },

  regions: {
    orderDeviceCollection: '@ui.orderDeviceCollection'
  },

  collection: null,

  onClickToggle() {
    const id = this.model.get('id').concat('-caret');
    const caret = document.getElementById(id);
    if (caret.classList.contains('fa-caret-down')) {
      caret.classList.remove('fa-caret-down');
      caret.classList.add('fa-caret-up');
    } else if (caret.classList.contains('fa-caret-up')) {
      caret.classList.remove('fa-caret-up');
      caret.classList.add('fa-caret-down');
    }
  },

  onRender() {
    this.collection = new Backbone.Collection([]);
    _.each(this.model.get('lineItems'), (item) => {
      const dev = new Backbone.Model(item);
      this.collection.add(dev);
    });

    if (this.model.get('isAdminEdit')) {
      this.showChildView(
        'orderDeviceCollection',
        new OrderDeviceAdminCollectionView({
          collection: this.collection
        })
      );
    } else {
      this.showChildView(
        'orderDeviceCollection',
        new OrderDeviceCollectionView({
          collection: this.collection
        })
      );
    }
  },

  async getDeviceData() {
    const orderType = this.model.get('orderType');
    switch (orderType) {
      case '4':
        return await this.onGetMaintenanceData();
      case '5':
        return this.onGetWideFormatData();
      case '6':
      case '10':
      case '11':
        return await this.onGetDesktopData();
      case '16':
        return this.onGetVB0Data();
      case '17':
        return this.onGetWideFormatData();
      case '18':
        return this.onGetVB0Data();
    }
  },

  onGetMaintenanceData() {
    const changedItems = [];
    const lineItems = this.model.get('lineItems');
    let numDevicesForMaintenance = 0;
    let numOnsiteTechnicians = 0;
    let numFirmwareSoftwareUpdates = 0;
    _.each(this.collection.models, (model) => {
      const item = _.find(lineItems, { id: model.id });
      if (model.get('quantity') !== '0') {
        switch (model.get('panel')) {
          case 'Type of Device Requiring Maintenance':
            numDevicesForMaintenance += parseInt(model.get('quantity'));
            break;
          case 'Additional Maintenance Services':
            if (model.get('model') === 'Onsite Technician') {
              numOnsiteTechnicians += parseInt(model.get('quantity'));
            } else if (
              model.get('model') === 'One Time Firmware/Software Update, Per Device, Completed by Contractor'
            ) {
              numFirmwareSoftwareUpdates += parseInt(model.get('quantity'));
            }
            break;
        }
      }
      if (model.get('quantity') !== item.quantity) {
        changedItems.push(model.attributes);
      }
    });
    const savedData = {
      changedItems,
      numDevicesForMaintenance,
      numOnsiteTechnicians,
      numFirmwareSoftwareUpdates
    };
    return savedData;
  },

  onGetWideFormatData() {
    const changedItems = [];
    const lineItems = this.model.get('lineItems');
    let totalPrinterQuantity = 0;
    let totalPrinterPrice = 0;
    let totalScannerQuantity = 0;
    let totalScannerPrice = 0;
    let totalCartridgeQuantity = 0;
    let totalCartridgePrice = 0;
    let totalPrinterCONUSPrice = 0;
    let totalPrinterCONUSQuantity = 0;
    let totalScannerCONUSQuantity = 0;
    let totalScannerCONUSPrice = 0;
    let totalCartridgeCONUSQuantity = 0;
    let totalCartridgeCONUSPrice = 0;
    let totalPrinterOCONUSPrice = 0;
    let totalPrinterOCONUSQuantity = 0;
    let totalScannerOCONUSPrice = 0;
    let totalScannerOCONUSQuantity = 0;
    let totalCartridgeOCONUSQuantity = 0;
    let totalCartridgeOCONUSPrice = 0;

    _.each(this.collection.models, (model) => {
      const item = _.find(lineItems, { id: model.id });
      if (model.get('quantity') !== '0') {
        const price = parseInt(model.get('totalPrice'));
        const quantity = parseInt(model.get('quantity'));
        switch (model.get('panel')) {
          case 'Printer':
            totalPrinterPrice += price;
            totalPrinterQuantity += quantity;
            break;
          case 'Scanner':
            totalScannerPrice += price;
            totalScannerQuantity += quantity;
            break;
          case 'Cartridge':
            totalCartridgePrice += price;
            totalCartridgeQuantity += quantity;
            break;
          case 'PrinterCONUS':
            totalPrinterCONUSPrice += price;
            totalPrinterCONUSQuantity += quantity;
            break;
          case 'ScannerCONUS':
            totalScannerCONUSPrice += price;
            totalScannerCONUSQuantity += quantity;
            break;
          case 'CartridgeCONUS':
            totalCartridgeCONUSPrice += price;
            totalCartridgeCONUSQuantity += quantity;
            break;
          case 'PrinterOCONUS':
            totalPrinterOCONUSPrice += price;
            totalPrinterOCONUSQuantity += quantity;
            break;
          case 'ScannerOCONUS':
            totalScannerOCONUSPrice += price;
            totalScannerOCONUSQuantity += quantity;
            break;
          case 'CartridgeOCONUS':
            totalCartridgeOCONUSPrice += price;
            totalCartridgeOCONUSQuantity += quantity;
            break;
        }
      }
      if (model.get('quantity') !== item.quantity) {
        changedItems.push(model.attributes);
      }
    });
    const savedData = {
      changedItems,
      totalPrinterPrice,
      totalPrinterQuantity,
      totalScannerPrice,
      totalScannerQuantity,
      totalCartridgePrice,
      totalCartridgeQuantity,
      totalPrinterCONUSPrice,
      totalPrinterCONUSQuantity,
      totalScannerCONUSPrice,
      totalScannerCONUSQuantity,
      totalCartridgeCONUSPrice,
      totalCartridgeCONUSQuantity,
      totalPrinterOCONUSPrice,
      totalPrinterOCONUSQuantity,
      totalScannerOCONUSPrice,
      totalScannerOCONUSQuantity,
      totalCartridgeOCONUSPrice,
      totalCartridgeOCONUSQuantity
    };
    return savedData;
  },

  onGetDesktopData() {
    const changedItems = [];
    const lineItems = this.model.get('lineItems');
    let totalPrinterQuantity = 0;
    let totalPrinterPrice = 0;
    let totalTonerQuantity = 0;
    let totalTonerPrice = 0;
    let totalScannerQuantity = 0;
    let totalScannerPrice = 0;
    _.each(this.collection.models, (model) => {
      const item = _.find(lineItems, { id: model.id });
      if (model.get('quantity') !== '0') {
        switch (model.get('panel')) {
          case 'Printer':
            totalPrinterPrice += model.get('totalPrice');
            totalPrinterQuantity += parseInt(model.get('quantity'));
            break;
          case 'Scanner':
            totalScannerPrice += model.get('totalPrice');
            totalScannerQuantity += parseInt(model.get('quantity'));
            break;
          case 'Toner':
            totalTonerPrice += model.get('totalPrice');
            totalTonerQuantity += parseInt(model.get('quantity'));
            break;
        }
      }
      if (model.get('quantity') !== item.quantity) {
        changedItems.push(model.attributes);
      }
    });
    const savedData = {
      changedItems,
      totalPrinterPrice,
      totalPrinterQuantity,
      totalScannerPrice,
      totalScannerQuantity,
      totalTonerPrice,
      totalTonerQuantity
    };
    return savedData;
  },

  onGetVB0Data() {
    const changedItems = [];
    const lineItems = this.model.get('lineItems');
    let totalPrinterQuantity = 0;
    let totalPrinterPrice = 0;
    let totalScannerQuantity = 0;
    let totalScannerPrice = 0;
    let totalCartridgeQuantity = 0;
    let totalCartridgePrice = 0;
    _.each(this.collection.models, (model) => {
      const item = _.find(lineItems, { id: model.id });
      if (model.get('quantity') !== '0') {
        switch (model.get('panel')) {
          case 'Printer':
            totalPrinterPrice += model.get('totalPrice');
            totalPrinterQuantity += parseInt(model.get('quantity'));
            break;
          case 'Scanner':
            totalScannerPrice += model.get('totalPrice');
            totalScannerQuantity += parseInt(model.get('quantity'));
            break;
          case 'Cartridge':
            totalCartridgePrice += model.get('totalPrice');
            totalCartridgeQuantity += parseInt(model.get('quantity'));
            break;
        }
      }
      if (model.get('quantity') !== item.quantity) {
        changedItems.push(model.attributes);
      }
    });
    const savedData = {
      changedItems,
      totalPrinterPrice,
      totalPrinterQuantity,
      totalScannerPrice,
      totalScannerQuantity,
      totalCartridgePrice,
      totalCartridgeQuantity
    };
    return savedData;
  }
});

export default OrderDeviceSectionView;
